import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TslSessionService } from 'projects/aztalena-core/src/public-api';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private session = inject(TslSessionService);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.session.accessToken) {
      this.router.navigate(['sign-in'], {
        queryParams: { returnUrl: state.url }
      });
      return false;
    }
    return true;
  }
}
